import { ANNOTATION_LABEL_FONT_WIDTH } from "./constants";
import { getWidth } from "./getXStartAndWidthOfRowAnnotation";
let measureCanvas;
export function getAnnotationTextWidth(text, fontSize = ANNOTATION_LABEL_FONT_WIDTH, fontFamily = "monospace") {
  if (!measureCanvas) {
    measureCanvas = document.createElement("canvas");
  }
  const ctx = measureCanvas.getContext && measureCanvas.getContext("2d");
  if (!ctx) {
    return (text || "").length * (fontSize || ANNOTATION_LABEL_FONT_WIDTH) * 0.6;
  }
  ctx.font = `${fontSize}px ${fontFamily}`;
  return ctx.measureText(text).width;
}
export const doesLabelFitInAnnotation = (text = "", { range, width }, charWidth) => {
  const textLength = getAnnotationTextWidth(text);
  const widthMinusOne = range ? getWidth(range, charWidth, 0) - ANNOTATION_LABEL_FONT_WIDTH * 2 : width - ANNOTATION_LABEL_FONT_WIDTH * 2;
  return widthMinusOne > textLength;
};
